import { render, staticRenderFns } from "./ObjektiCard2Tab-7-Lokacija.vue?vue&type=template&id=0ede4c78&scoped=true&"
import script from "./ObjektiCard2Tab-7-Lokacija.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-7-Lokacija.vue?vue&type=script&lang=ts&"
import style0 from "./ObjektiCard2Tab-7-Lokacija.vue?vue&type=style&index=0&id=0ede4c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede4c78",
  null
  
)

export default component.exports